import React, { PropsWithChildren } from 'react'
import {
  Menu as MUIMenu,
  MenuProps,
  MenuList,
  MenuListProps,
  MenuItem,
  MenuItemProps,
  ThemeOptions,
} from '@mui/material'

const Menu: React.FC<PropsWithChildren & MenuProps> = ({
  children,
  ...props
}) => (
  <MUIMenu
    anchorOrigin={{
      vertical: 'bottom',
      horizontal: 'left',
    }}
    transformOrigin={{
      vertical: 'top',
      horizontal: 'left',
    }}
    component='nav'
    {...props}
  >
    {children}
  </MUIMenu>
)

export { Menu, MenuList, MenuItem }

export type { MenuProps, MenuListProps, MenuItemProps }

export const menuThemeOverrides: ThemeOptions['components'] = {
  MuiListItemIcon: {
    styleOverrides: {
      root: ({ theme }) => ({
        color: theme.palette.action.active,
      }),
    },
  },
}
